export function InlineLoading({ label = '正在加载' }: { label?: string }) {
  return (
    <div className="flex min-h-44 items-center justify-center gap-1.5" role="status" aria-label={label}>
      {[0, 120, 240].map((delay) => (
        <span
          key={delay}
          className="h-2 w-2 motion-safe:animate-pulse rounded-[var(--radius-pill)] bg-[var(--color-primary)]"
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </div>
  )
}

export const Loading = InlineLoading
